import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface BankInfo {
//   bankCardId?: string;
//   bankCardName?: string;
//   bankCardKey?: string;
//   bankIcon?: string;
//   bankCardNum1?: string;
//   bankMobile?: string;
//   userName?: string;
// }
interface CommonState {
  userToken: string;
  language: string;
  // bankInfo: BankInfo;
}

const initialState: CommonState = {
  userToken: '',
  language: 'zh',
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setUserToken(state: any, action: PayloadAction<{ userToken: string }>) {
      state.userToken = action.payload.userToken;
    },

    // setBankInfo(state: any, action: PayloadAction<{ bankInfo: BankInfo }>) {
    //   state.bankInfo = {
    //     ...state.bankInfo,
    //     ...action.payload.bankInfo,
    //   };
    // },
  },
  extraReducers: () => {
    // 异步action成功的reducer执行
  },
});

const { setUserToken } = commonSlice.actions;

export { setUserToken };

export default commonSlice.reducer;
